/* 🤖 this file was generated by svg-to-ts */
export const matIconEdgesensorHigh: {
  name: 'edgesensor-high';
  data: string;
} = {
  name: 'edgesensor-high',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 7h2v7H3V7zm-3 3h2v7H0v-7zm22-3h2v7h-2V7zm-3 3h2v7h-2v-7zm-3-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 20H8v-1h8v1zm0-3H8V7h8v10zM8 5V4h8v1H8z"/></svg>`
};
